// extracted by mini-css-extract-plugin
module.exports = {"pageSection":"page-section_pageSection__DJoCO"};